// TODO: убрать отключение этого правила во всем проекте, когда обновят внутреннюю зависимость
//  eslint-plugin-node (https://github.com/eslint-community/eslint-plugin-n/pull/13)
/* eslint-disable node/no-unsupported-features/es-syntax */
// import * as Sentry from "@sentry/vue";
import { Chart as ChartJS } from "chart.js";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { setLocale } from "yup";

import { vEllipsisTooltip } from "@/shared";

import { takeJwtFromUrl } from "./lib/takeJwtFromUrl";
import { withI18n } from "./providers/withI18n";
import { withRouter, router } from "./providers/withRouter";
import App from "./ui/App.vue";

import "./styles/main.scss";

// Chart.js рендерит текст в canvas, который не наследует CSS font-family.
// Глобально настраиваем Inter (с кириллицей) для всех чартов (графики, doughnut и т.д.),
// иначе цифры на осях/тултипах выглядят дефолтным sans-serif рядом с Inter в DOM.
ChartJS.defaults.font.family =
    '"Inter", -apple-system, "Segoe UI", system-ui, sans-serif';
ChartJS.defaults.font.size = 12;
ChartJS.defaults.color = "#4a5360";

setLocale({
    mixed: {
        required: "Поле обязательно для заполнения",
    },
});

takeJwtFromUrl();

const app = createApp(App);

// Глобальная подсказка для обрезанных названий: при наведении показывает полный
// текст, если он не помещается. Доступна как v-ellipsis-tooltip во всех разделах.
app.directive("ellipsis-tooltip", vEllipsisTooltip);

// Sentry init
/* Sentry.init({
    app,
    dsn: "https://5c74265387bd9db18b4796e4f8e6054a@sentry.rentinhand.ru/5",
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
}); */

app.use(createPinia());
withRouter(app);

export const initApplication = async () => {
    await withI18n(app);

    if (Number(import.meta.env.VITE_SHOULD_ENABLE_MOCKS)) {
        const { faker } = await import("@faker-js/faker");

        faker.setLocale("ru");

        const { worker, onUnhandledRequest } = await import("./mocks/browser");

        await worker.start({ onUnhandledRequest });
    }

    // Дожидаемся разрешения стартового роута до монтирования: иначе компоненты
    // рендерятся против неразрешённого роута (route.meta пустой) и падают — белый экран.
    await router.isReady();

    app.mount("#app");
};
